//
//
//
//
//
//

  export default {
    name: 'App'
  }



// WEBPACK FOOTER //
// ./src/App.vue